<template>
  <div>
    <b-card header="진행 중 사전예약 카드">
      <b-table hover striped bordered small fixed responsive="sm" :items="pregCardListWithMomentGamesSlotNow"
               :fields="fields" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sort-desc=true>
        <template slot="table-caption">
          CARD 01
        </template>
        <template slot="startTime" slot-scope="data">
          {{ data.item.startTime.format('YY.MM.DD HH:mm') }}
        </template>
        <template slot="endTime" slot-scope="data">
          {{ data.item.endTime.format('YY.MM.DD HH:mm') }}
        </template>

        <template slot="displayYn" slot-scope="data">
          <select :ref="'type' + data.item.seq" :value="data.item.displayYn" v-on:change="changeHandling(data.item, $event)">
            <option :value=DISPLAY_STATE.ON>ON</option>
            <option :value=DISPLAY_STATE.OFF>OFF</option>
            <option :value=DISPLAY_STATE.BETA>BETA</option>
          </select>
        </template>

        <template slot="management" slot-scope="data">
          <!--<b-link :to="{name: 'cardListEdit', params: {pregId: data.item.pregMasterId, seq: data.item.seq}}" class="mr-2">[수정]</b-link>-->
          <b-link @click="moveEditPage(data.item)" class="mr-2">[수정]</b-link>
          <b-link v-on:click="deleteHandling(data.item.seq)">[삭제]</b-link>
        </template>
      </b-table>

      <b-table hover striped bordered small fixed responsive="sm" :items="pregCardListWithMomentKakaoSlotNow"
               :fields="fields" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sort-desc=true>
        <template slot="table-caption">
          CARD 02
        </template>
        <template slot="startTime" slot-scope="data">
          {{ data.item.startTime.format('YY.MM.DD HH:mm') }}
        </template>
        <template slot="endTime" slot-scope="data">
          {{ data.item.endTime.format('YY.MM.DD HH:mm') }}
        </template>

        <template slot="displayYn" slot-scope="data">
          <select :ref="'type' + data.item.seq" :value="data.item.displayYn" v-on:change="changeHandling(data.item, $event)">
            <option :value=DISPLAY_STATE.ON>ON</option>
            <option :value=DISPLAY_STATE.OFF>OFF</option>
            <option :value=DISPLAY_STATE.BETA>BETA</option>
          </select>
        </template>

        <template slot="management" slot-scope="data">
          <!--<b-link :to="{name: 'cardListEdit', params: {pregId: data.item.pregMasterId, seq: data.item.seq}}" class="mr-2">[수정]</b-link>-->
          <b-link @click="moveEditPage(data.item)" class="mr-2">[수정]</b-link>
          <b-link v-on:click="deleteHandling(data.item.seq)">[삭제]</b-link>
        </template>
      </b-table>

    </b-card>

    <b-card header="진행 예정 사전예약 카드">
      <b-table hover striped bordered small fixed responsive="sm" :items="pregCardListWithMomentGamesSlotFuture"
               :fields="fields" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sort-desc=true>
        <template slot="table-caption">
          CARD 01
        </template>
        <template slot="startTime" slot-scope="data">
          {{ data.item.startTime.format('YY.MM.DD HH:mm') }}
        </template>
        <template slot="endTime" slot-scope="data">
          {{ data.item.endTime.format('YY.MM.DD HH:mm') }}
        </template>

        <template slot="displayYn" slot-scope="data">
          <select :ref="'type' + data.item.seq" :value="data.item.displayYn" v-on:change="changeHandling(data.item, $event)">
            <option :value=DISPLAY_STATE.ON>ON</option>
            <option :value=DISPLAY_STATE.OFF>OFF</option>
            <option :value=DISPLAY_STATE.BETA>BETA</option>
          </select>
        </template>

        <template slot="management" slot-scope="data">
          <!--<b-link :to="{name: 'cardListEdit', params: {pregId: data.item.pregMasterId, seq: data.item.seq}}" class="mr-2">[수정]</b-link>-->
          <b-link @click="moveEditPage(data.item)" class="mr-2">[수정]</b-link>
          <b-link v-on:click="deleteHandling(data.item.seq)">[삭제]</b-link>
        </template>
      </b-table>

      <b-table hover striped bordered small fixed responsive="sm" :items="pregCardListWithMomentKakaoSlotFuture"
               :fields="fields" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sort-desc=true>
        <template slot="table-caption">
          CARD 02
        </template>
        <template slot="startTime" slot-scope="data">
          {{ data.item.startTime.format('YY.MM.DD HH:mm') }}
        </template>
        <template slot="endTime" slot-scope="data">
          {{ data.item.endTime.format('YY.MM.DD HH:mm') }}
        </template>

        <template slot="displayYn" slot-scope="data">
          <select :ref="'type' + data.item.seq" :value="data.item.displayYn" v-on:change="changeHandling(data.item, $event)">
            <option :value=DISPLAY_STATE.ON>ON</option>
            <option :value=DISPLAY_STATE.OFF>OFF</option>
            <option :value=DISPLAY_STATE.BETA>BETA</option>
          </select>
        </template>

        <template slot="management" slot-scope="data">
          <!--<b-link :to="{name: 'cardListEdit', params: {pregId: data.item.pregMasterId, seq: data.item.seq}}" class="mr-2">[수정]</b-link>-->
          <b-link @click="moveEditPage(data.item)" class="mr-2">[수정]</b-link>
          <b-link v-on:click="deleteHandling(data.item.seq)">[삭제]</b-link>
        </template>
      </b-table>

    </b-card>

    <b-card header="종료 된 사전예약 카드">
      <b-table hover striped bordered small fixed responsive="sm" :items="pregCardListWithMomentGamesSlotPast"
               :fields="fields" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sort-desc=true>
        <template slot="table-caption">
          CARD 01
        </template>
        <template slot="startTime" slot-scope="data">
          {{ data.item.startTime.format('YY.MM.DD HH:mm') }}
        </template>
        <template slot="endTime" slot-scope="data">
          {{ data.item.endTime.format('YY.MM.DD HH:mm') }}
        </template>

        <template slot="displayYn" slot-scope="data">
          <select :ref="'type' + data.item.seq" :value="data.item.displayYn" v-on:change="changeHandling(data.item, $event)">
            <option :value=DISPLAY_STATE.ON>ON</option>
            <option :value=DISPLAY_STATE.OFF>OFF</option>
            <option :value=DISPLAY_STATE.BETA>BETA</option>
          </select>
        </template>

        <template slot="management" slot-scope="data">
          <!--<b-link :to="{name: 'cardListEdit', params: {pregId: data.item.pregMasterId, seq: data.item.seq}}" class="mr-2">[수정]</b-link>-->
          <b-link @click="moveEditPage(data.item)" class="mr-2">[수정]</b-link>
          <b-link v-on:click="deleteHandling(data.item.seq)">[삭제]</b-link>
        </template>
      </b-table>

      <b-table hover striped bordered small fixed responsive="sm" :items="pregCardListWithMomentKakaoSlotPast"
               :fields="fields" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sort-desc=true>
        <template slot="table-caption">
          CARD 02
        </template>
        <template slot="startTime" slot-scope="data">
          {{ data.item.startTime.format('YY.MM.DD HH:mm') }}
        </template>
        <template slot="endTime" slot-scope="data">
          {{ data.item.endTime.format('YY.MM.DD HH:mm') }}
        </template>

        <template slot="displayYn" slot-scope="data">
          <select :ref="'type' + data.item.seq" :value="data.item.displayYn" v-on:change="changeHandling(data.item, $event)">
            <option :value=DISPLAY_STATE.ON>ON</option>
            <option :value=DISPLAY_STATE.OFF>OFF</option>
            <option :value=DISPLAY_STATE.BETA>BETA</option>
          </select>
        </template>

        <template slot="management" slot-scope="data">
          <!--<b-link :to="{name: 'cardListEdit', params: {pregId: data.item.pregMasterId, seq: data.item.seq}}" class="mr-2">[수정]</b-link>-->
          <b-link @click="moveEditPage(data.item)" class="mr-2">[수정]</b-link>
          <b-link v-on:click="deleteHandling(data.item.seq)">[삭제]</b-link>
        </template>
      </b-table>

    </b-card>

  </div>
</template>
<script>
import { MODULE_NAME as PLAYGAME_MODULE, FETCH_PREG_CARD_LIST } from '@/store/playGame/actions.type'
// import { MODULE_NAME as PREG_MODULE, FETCH_CODES } from '@/store/preg/actions.type'
import { $showModalWithErrorMsg } from '@/common/util'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { GAMES_SLOT, KAKAO_SLOT, DISPLAY_STATE } from '@/constants'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import { REMOVE_BY_SEQ } from '@/store/playGame/mutations.type'
import playGameService from '@/common/api/playGame.service'
const FUTURE = 'future'
const NOW = 'now'
const PAST = 'past'
export default {
  data () {
    return {
      DISPLAY_STATE: DISPLAY_STATE,
      fields: [
        {key: 'pregMasterId', label: 'id', class: 'align-middle text-center', thStyle: {width: '50px'}},
        {key: 'pregName', label: '제목', class: 'align-middle text-center'},
        {key: 'startTime', label: '시작일', class: 'align-middle text-center', sortable: true, thStyle: {width: '150px'}},
        {key: 'endTime', label: '종료일', class: 'align-middle text-center', sortable: true, thStyle: {width: '150px'}},
        {key: 'osType', label: 'OS', class: 'align-middle text-center', sortable: true, thStyle: {width: '150px'}},
        {key: 'displayYn', label: 'ON/OFF', class: 'align-middle text-center', sortable: true, thStyle: {width: '150px'}},
        {key: 'management', label: '관리', class: 'align-middle text-center', thStyle: {width: '150px'}}
      ]
    }
  },
  mounted () {
    this.$store.dispatch(PLAYGAME_MODULE + FETCH_PREG_CARD_LIST)
      .then(() => {
        console.log('this.pregCardList')
        console.log(this.pregCardList)
        console.log(this.pregCardListWithMoment)
      })
      .catch($showModalWithErrorMsg.bind(this))
    // this.$store.dispatch(PREG_MODULE + FETCH_CODES)
    //   .catch($showModalWithErrorMsg.bind(this))
  },
  methods: {
    changeHandling(item, event) {
      // 바꾸려고 선택한 값 : event.target.value
      // 기존 값 값 : item.displayYn
      const BERFORE = item.displayYn
      const SELECTED = parseInt(event.target.value)

      let confirmText

      if(SELECTED === DISPLAY_STATE.ON) {
        confirmText = '노출(ON) 하시겠습니까?'
      } else if (SELECTED === DISPLAY_STATE.OFF) {
        confirmText = '비 노출(Off) 하시겠습니까?'
      } else {
        confirmText = '베타 테스트용 노출 (BETA) 하시겠습니까?'
      }

      let isToggle = window.confirm(confirmText)
      let fail = () => {
        this.$refs['type' + item.seq].value = BERFORE
        item.displayYn = BERFORE
        $showModalWithErrorMsg.bind(this)
      }

      if (isToggle) {
        item.displayYn = SELECTED

        playGameService.updatePregCard(item)
          .then((res) => {
            this[SHOW_MODAL]({msg: '수정이 완료되었습니다.', okHandling: () => { this.$router.push({name: 'cardListContents'}) }})
          })
          .catch((err) => {
            if (err.response.data.msg) {
              this[SHOW_MODAL]({msg: err.response.data.msg, okHandling: () => {}})
            } else {
              throw err
            }
          })
          .catch($showModalWithErrorMsg.bind(this))

      } else {
        this.$refs['type' + item.seq].value = BERFORE
        item.displayYn = BERFORE
      }
    },
    deleteHandling (seq) {
      playGameService.deletePregCard(seq)
        .then((res) => {
          this[REMOVE_BY_SEQ](seq)
          this[SHOW_MODAL]({msg: '삭제하였습니다.', okHandling: () => {}})
        })
    },
    moveEditPage(item) {
      console.log('moveEditPage')
      console.log(item)
      if (item.pregMasterId < 1000) {
        this.$router.push({name: 'cardListEdit', params: {pregId: '' +item.pregMasterId, seq: '' + item.seq}})
      } else {
        this.$router.push({name: 'gapCardListEdit', params: {pregId: '' + item.pregMasterId, seq: '' + item.seq}})
      }
    },
    ...mapMutations('ui', [SHOW_MODAL]),
    ...mapMutations(PLAYGAME_MODULE, [REMOVE_BY_SEQ])
  },
  computed: {
    pregCardListWithMomentGamesSlotNow () {
      return this.pregCardListWithMoment.filter((elem) => {
        return elem.slotNo === GAMES_SLOT && elem.status === NOW
      })
    },
    pregCardListWithMomentKakaoSlotNow () {
      return this.pregCardListWithMoment.filter((elem) => {
        return elem.slotNo === KAKAO_SLOT && elem.status === NOW
      })
    },
    pregCardListWithMomentGamesSlotFuture () {
      return this.pregCardListWithMoment.filter((elem) => {
        return elem.slotNo === GAMES_SLOT && elem.status === FUTURE
      })
    },
    pregCardListWithMomentKakaoSlotFuture () {
      return this.pregCardListWithMoment.filter((elem) => {
        return elem.slotNo === KAKAO_SLOT && elem.status === FUTURE
      })
    },
    pregCardListWithMomentGamesSlotPast () {
      return this.pregCardListWithMoment.filter((elem) => {
        return elem.slotNo === GAMES_SLOT && elem.status === PAST
      })
    },
    pregCardListWithMomentKakaoSlotPast () {
      return this.pregCardListWithMoment.filter((elem) => {
        return elem.slotNo === KAKAO_SLOT && elem.status === PAST
      })
    },
    // ...mapState(PREG_MODULE, [
    //   'codes'
    // ]),
    ...mapState(PLAYGAME_MODULE, [
      'pregCardList'
    ]),
    ...mapGetters(PLAYGAME_MODULE, [
      'pregCardListWithMoment'
    ])
  },
}
</script>
